import { render, staticRenderFns } from "./produtos.vue?vue&type=template&id=2d2539ec"
import script from "./produtos.vue?vue&type=script&lang=js"
export * from "./produtos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports